var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSatisfactory(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 13.625H14M13 7.625H13.01M7 7.625H7.01M19 10.625C19 15.5956 14.9706 19.625 10 19.625C5.02944 19.625 1 15.5956 1 10.625C1 5.65444 5.02944 1.625 10 1.625C14.9706 1.625 19 5.65444 19 10.625Z",
    stroke: "#92D050",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSatisfactory);
export default __webpack_public_path__ + "static/media/satisfactory.c9268db42c2e67ea8f5c2a46a14b3b31.svg";
export { ForwardRef as ReactComponent };